import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';

import Documents from './Documents';
import ImageManagement from './ImageManagement';

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
};

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

const FileManagement = () => {
    const [tab, setTab] = React.useState(0);

    return (
        <>
            <AppBar
                position="sticky"
                color="inherit"
                sx={{ top: 64 }}
            >
                <Tabs value={tab} onChange={(e, value) => setTab(value)}>
                    <Tab label="Image Library" />
                    <Tab label="Document Library" />
                </Tabs>
            </AppBar>
            <Box>
                <CustomTabPanel value={tab} index={0}>
                    <ImageManagement />
                </CustomTabPanel>
                <CustomTabPanel value={tab} index={1}>
                    <Documents />
                </CustomTabPanel>
            </Box>
        </>
    );
};

export default FileManagement;